import React from 'react';

import RichEditorContent from 'components/RichEditorContent';

import AbstractCmsElement from 'components/cms/elements/AbstractCmsElementNew';

export default class CmsElementTimelineBlock extends AbstractCmsElement {
  render() {
    return (
      <div className="timeline-block">
        <div className="timeline-point complete text-center">
          <i className={this.getParamValue('icon', 'far fa-circle')} />
        </div>
        <div className="timeline-content">
          <div className="card share full-width">
            <div className="card-block">
              <RichEditorContent content={'<p className="no-margin">' + this.getParamValue('content', '') + '</p>'} />
            </div>
            <div className="event-date">
              <small className="fs-12 hint-text">
                <span>{this.getParamValue('title', '')}</span>
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
